import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { Produtos } from '../model/produtos.model';

import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class ProdutosService {

  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getAll(params: any): Observable<any>{
    const url = `${this.baseUrl}produtos`;
    return this.http.get<any>(url, {params})
  }

  listarService(): Observable<Produtos[]>{
    const url = `${this.baseUrl}produtos/listarTodos`;
    return this.http.get<Produtos[]>(url);
  }

  listarIdService(id: any): Observable<Produtos> {
    const url = `${this.baseUrl}produtos/${id}`;
    return this.http.get<Produtos>(url);
  }

  atualizarService(produto: Produtos): Observable<Produtos>{
    const url = `${this.baseUrl}produtos/atualizar/${produto.sr_id}`;
    return this.http.put<Produtos>(url, produto);
  }

  cadastrarService(produto: Produtos): Observable<Produtos>{
    const url = `${this.baseUrl}produtos/cadastro`;
    return this.http.post<Produtos>(url, produto);
  }

  statusService(produto: Produtos): Observable<any>{
    var status = new Object();
    status = {'status': produto.bl_status}
    const url = `${this.baseUrl}produtos/status/${produto.sr_id}`;
    return this.http.put<any>(url, status)
  }

  public confirmAlert(produto: any): void {
    Swal.fire({
      title: 'Desativar produto?',
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#df4747',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        produto.bl_status = 0;
        this.statusService(produto).subscribe((resp) => {})
      }
    })
  }

  public desativarAlert(produto: any): void {
    Swal.fire({
      title: 'Ativar produto?',
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#df4747',
      confirmButtonText: 'Confirmar!'
    }).then((result) => {
      if (result.isConfirmed) {
        produto.bl_status = 1;
        this.statusService(produto).subscribe((resp) => {})
      }
    })
  }
}
